import { render } from "./App.vue?vue&type=template&id=66851a72"
const script = {}
script.render = render

export default script